export const colors = {
  white: '#fff',
  primary: '#21d48d',
  background: '#111c1c',
  yellow: 'rgb(255, 202, 68)',
  red: '#ee3333'
};